export function checkRnr(input: string, patterns: String[]): boolean {
  for (let i = 0; i < patterns.length; i++) {
    const pattern = patterns[i];
    const stringArray = pattern.split(":");
    const regEx = new RegExp(stringArray[0]);
    if (regEx.test(input)) {
      return true;
    }
  }
  return false;
}
